import { TranslatePipe } from '../../filters/translate.pipe';
import { CardJoinRequestsComponent } from '../../components/card-join-requests/card-join-requests.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import RoutingService from '../../services/routing.service';
import { PanelDirective } from '../../directives/panel.directive';

@Component({
	standalone: true,
	selector: 'join-requests',
	templateUrl: './join-requests.component.html',
	imports: [ CommonModule, PanelDirective, TranslatePipe, CardJoinRequestsComponent, FormsModule ]
})
export default class JoinRequestsView implements OnInit {
	private session: Session = inject(Session);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('employees').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
	}
	
}